<template>
  <div>
    <b-modal
      id="assign-staff-coTeamLeader"
      ref="modal"
      header-class="headerModal"
      centered
      :title="$t('AssignCo-TeamLeaderToFiliale')"
      no-close-on-backdrop
      size="l"
      hide-footer
      @close="onCancel"
    >
      <b-form>
        <b-form-group
          id="input-group-2"
          :label="$t('Co-TeamLeader')"
          label-for="input-2"
        >
          <vue-select
            v-model="coTeamLeader"
            required
            :options="getfreeCoTeamLeaders"
            label="userFullName"
            :value="userId"
            :placeholder="$t('Select')"
            aria-describedby="input-1-live-feedback"
          />
        </b-form-group>
        <!-- <b-form-group
          id="input-group-2"
          label="Co-TeamLeader"
          label-for="input-2"
        >
          <vue-select
            v-model="coTeamLeader"
            required
            :options="getfreeCoTeamLeaders"
            label="userFullName"
            :value="userId"
            placeholder="Select TeamLeader"
            aria-describedby="input-1-live-feedback"
          />
        </b-form-group> -->
        <pre />
        <div style="width: 110%">
          <b-button
            type="button"
            variant="none"
            class="buttonSubmit"
            @click="AssignTeamLeader"
          >
            {{ $t("Submit") }}
          </b-button>
          <b-button
            type="button"
            variant="danger"
            class="buttonCancel"
            style="margin-right: 5px"
            @click="onCancel"
          >
            {{ $t("Cancel") }}
          </b-button>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  components: {},
  props: ['storeId', 'createOrder'],
  data() {
    return {
      userId: null,
      coTeamLeader: null,
      isPhoneNumberValid: null,
      config: {
        altInput: true,
        altFormat: 'd-m-Y',
        dateFormat: 'Y-m-d',
      },
      form: {
        storeId: null,
        employeeUserId: null,
        isTeamLeader: false,
        isManager: false,
        isCoTeamLeader: true,
      },
    };
  },
  computed: {
    ...mapGetters(['getfreeCoTeamLeaders']),

    // getSal() {
    //   return this.$store.state.login.salutation;
    // },
  },

  watch: {
    'coTeamLeader.userId': {
      handler(value) {
        this.form.employeeUserId = value;
      },
      immediate: true,
    },
    storeId: {
      handler(value) {
        this.form.storeId = value;
      },
      immediate: true,
    },
  },
  mounted() {
    this.form.storeId = this.storeId
  },
  methods: {
    ...mapActions(['loadUsersFullNamesById']),
    AssignTeamLeader() {
      this.$emit('assignCoTeamLeader', this.form);
      this.$refs.modal.hide();
      this.onReset();
    },
    onCancel() {
      this.$refs.modal.hide();
      this.onReset();
    },
    onReset() {
      // Reset our form values
      // this.form.storeId = '';
      // Trick to reset/clear native browser form validation state
      this.coTeamLeader = '';
    },
  },
};
</script>

<style lang="scss" scoped>
// form {
//   display: grid;
//   grid-template-columns: 1fr 1fr;
//   gap: 10px;
// }
// .form {
//   display: grid;
//   grid-template-columns: 1fr 1fr;
//   gap: 10px;
// }
.form2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}
.flex-form {
  display: flex;
  flex-direction: column;
}
.uploadButtons {
  display: flex;
  align-items: flex-end;
}
</style>
